import commonConfig from './common.json';

export default {
  env: process.env.NODE_ENV,
  ...commonConfig,
};
